import { ColocaSwitch } from "@/shared/components/forms/ColocaSwitch";

export interface FeeBearerSwitchProps {
  label: string;
  hint: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function FeeBearerSwitch({ label, hint, checked, onCheckedChange }: FeeBearerSwitchProps) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-border bg-card px-4 py-3">
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-foreground">{label}</span>
        <span className="mt-0.5 block text-xs text-muted-foreground">{hint}</span>
      </span>
      <ColocaSwitch checked={checked} onCheckedChange={onCheckedChange} />
    </label>
  );
}
